import React from "react";
import styles from "../../pages/styles";
import { foxtail, textlogo } from "../../assets/images";

const HeroClasses = ({ title, tagline, desc, img }) => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 px-4 md:px-20 py-8 md:py-12 max-w-7xl mx-auto">
      <div className="flex-1 text-center md:text-left">
        <div className="flex md:justify-start justify-center mb-6">
          <img alt="Tech Tails" src={textlogo} className="w-32 md:w-40" />
        </div>
        <h1 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
          {title}
        </h1>
        <h2 className={`${styles.headingdark} mb-3 md:mb-4`}>
          {tagline}
        </h2>
        <p className={`${styles.paragraph} max-w-xl mx-auto md:mx-0`}>{desc}</p>
      </div>
      <div className="flex-1 flex justify-center">
        <img
          src={img}
          alt={`${title} class`}
          className="w-full max-w-[500px] rounded-2xl"
        />
      </div>
    </div>
  );
};

export default HeroClasses;
